import MultiplePriceCell from 'Presentation/Components/RequestCard/Components/MultiplePrice'

const QuotePriceCell: React.FC<any> = props => {
	const index = props.row.index
	const { canInput, onChange } = props.cell.column
	const { documentStatus, quotePrice } = props.row.original

	if (documentStatus === '10') {
		return (
			<div className="d-flex justify-content-end">
				<input
					placeholder="กรุณากรอกราคา"
					disabled={canInput}
					type="text"
					className="form-control form-control-sm w-75"
					value={quotePrice}
					onChange={e => onChange(e.target.value, index)}
				/>
			</div>
		)
	} else {
		return <MultiplePriceCell prices={quotePrice} />
	}
}

export default QuotePriceCell
